import styled from 'styled-components'
import { TopBidders } from './TopBidders/TopBidders'
import { MostPopularGames } from './MostPopularGames/MostPopularGames'
import { TopAssets } from './TopAssets/TopAssets'
import { Information } from './Information/Information'
import { Carrousel } from './Carrousel'

export const YoloLanding = () => {
  return (
    <LandingContainer>
      <Carrousel />
      {/* <TopBidders /> */}
      <MostPopularGames />
      <TopAssets />
      <Information />
    </LandingContainer>
  )
}

const LandingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  /* width: 100%; */
  height: calc(100% - 80px);
  overflow-y: auto;
  overflow-x: hidden;
  margin: 80px 0;

  #pageWrapper {
    width: 90%;
  }
`
